import Global from "@/scripts/Global";
import VueSignals from '@/scripts/VueSignals'

export default {
    name: 'ConfirmDeleteMessage',
    data() {
        return {
            currData: {
                'message_id': '',
            },
            confirmCheck: false,
        }
    },
    mounted() {
        this.currData = this.$parent.data
    },
    methods: {
        deleteMessage() {
            Global.globalValue(VueSignals.DELETE_MESSAGE, this.currData.message_id);
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, false);
        }
    }
}
